module.exports = __webpack_public_path__ + "static/media/Search_orange.c4f1d7bf.svg";